import type { EngineModule } from "./types";
import { genericEngine } from "./generic/DomainGrid";
import { humanDesignEngine } from "./human-design/Bodygraph";
import { kafrequencyEngine } from "./kafrequency/ChakraColumn";

/**
 * Engine registry — add a new curriculum's visualization by dropping a module
 * here and giving its domain the matching `engine_key` in the database.
 * When `engine_key` is null or unknown, the generic grid is used.
 */
export const engineRegistry: Record<string, EngineModule> = {
  human_design: humanDesignEngine,
  kafrequency: kafrequencyEngine,
  generic: genericEngine,
};

export function resolveEngine(key: string | null | undefined): EngineModule {
  if (key && engineRegistry[key]) return engineRegistry[key];
  return genericEngine;
}

export const engineKeys = Object.keys(engineRegistry);
export type { EngineModule, EngineHeroProps, InteractiveNode, EngineDomain } from "./types";
